import React, { useState } from "react";
import { Button, Input, Select, message } from "antd";
import { PlusOutlined, DeleteOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { ISite } from "../../types/ISite";
import './Site.scss';

export default function Site({ site, setSite, sites, addSite, deleteSite, next }: ISite) {
    const [val, setVal] = useState('');

    const mappedSites = sites.map(el => ({ label: el.name, value: el.slug }));

    const handleAdd = () => {
        if (!val.trim()) return;
        addSite(val.trim());
        setVal('');
        message.success('Podstrona dodana');
    };

    const handleDelete = () => {
        deleteSite(site);
        message.success('Podstrona usunięta');
    };

    return (
        <div className='site'>
            <div className='site__panel'>
                <h2 className='site__heading'>Wybierz podstronę</h2>
                <p className='site__sub'>Wybierz podstronę, którą chcesz edytować lub usunąć.</p>
                <Select
                    options={mappedSites}
                    value={site || undefined}
                    onChange={(value) => setSite(value)}
                    placeholder="Wybierz podstronę..."
                    className='site__select'
                />
                {site && (
                    <div className='site__actions'>
                        <Button danger icon={<DeleteOutlined />} onClick={handleDelete}>
                            Usuń
                        </Button>
                        <Button type='primary' icon={<ArrowRightOutlined />} onClick={() => next()}>
                            Wybierz
                        </Button>
                    </div>
                )}
            </div>

            <div className='site__divider' />

            <div className='site__panel'>
                <h2 className='site__heading'>Dodaj podstronę</h2>
                <p className='site__sub'>Wpisz nazwę nowej podstrony i kliknij Dodaj.</p>
                <Input
                    placeholder="Nazwa podstrony"
                    value={val}
                    onChange={(e) => setVal(e.target.value)}
                    onPressEnter={handleAdd}
                    className='site__input'
                />
                <Button icon={<PlusOutlined />} onClick={handleAdd} disabled={!val.trim()}>
                    Dodaj
                </Button>
            </div>
        </div>
    );
}
